/* ログ一覧検索コントロール */
import React, { useState } from 'react';
import { Button, Col, Form, InputGroup, Row } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import ja from '../lang/ja';

type Props = {
  handleClickSearch: (params: Object) => void;
};

const form_initialstate = {
  reception_cd: '',
  error_level: '',
  ip_address: '',
  start_date: null,
  end_date: null,
  error_message: '',
};

const LogSearchForm: React.FC<Props> = ({ handleClickSearch }) => {
  const [form, setForm] = useState(form_initialstate);
  const handleChange = (name: string, value: string | Date | [Date, Date] | null) =>
    setForm(prev => ({ ...prev, [name]: value }));

  const handleClear = () => setForm(form_initialstate);

  return (
    <Form>
      <Row className="mb-3">
        <Form.Group as={Col}>
          <Form.Label>発生日時</Form.Label>
          <InputGroup>
            <DatePicker
              className="form-control"
              wrapperClassName="form-control"
              name="start_date"
              locale={ja}
              selected={form.start_date}
              onChange={event => handleChange('start_date', event)}
              dateFormat="yyyy-MM-dd"
              selectsStart
              autoComplete="off"
              startDate={form.start_date}
              endDate={form.end_date}
            />
            <Form.Label className="mt-auto">~</Form.Label>
            <DatePicker
              className="form-control"
              wrapperClassName="form-control"
              name="end_date"
              locale={ja}
              selected={form.end_date}
              onChange={event => handleChange('end_date', event)}
              dateFormat="yyyy-MM-dd"
              selectsEnd
              autoComplete="off"
              startDate={form.start_date}
              endDate={form.end_date}
              minDate={form.start_date}
            />
          </InputGroup>
        </Form.Group>
        <Form.Group as={Col}>
          <Form.Label>エラーレベル</Form.Label>
          <Form.Control
            as="select"
            name="error_level"
            value={form.error_level}
            onChange={event => handleChange(event.target.name, event.target.value)}
          >
            <option value=""></option>
            <option value="INFO">INFO</option>
            <option value="ERROR">ERROR</option>
            <option value="DEBUG">DEBUG</option>
          </Form.Control>
        </Form.Group>
      </Row>
      <Row className="mb-3">
        <Form.Group as={Col}>
          <Form.Label>案件コード</Form.Label>
          <Form.Control
            type="text"
            name="reception_cd"
            value={form.reception_cd}
            onChange={event => handleChange(event.target.name, event.target.value)}
          />
        </Form.Group>
        <Form.Group as={Col}>
          <Form.Label>エラーメッセージ</Form.Label>
          <Form.Control
            type="text"
            name="error_message"
            value={form.error_message}
            onChange={event => handleChange(event.target.name, event.target.value)}
          />
        </Form.Group>
        <Form.Group as={Col}>
          <Form.Label>IPアドレス</Form.Label>
          <Form.Control
            type="text"
            name="ip_address"
            value={form.ip_address}
            onChange={event => handleChange(event.target.name, event.target.value)}
          />
        </Form.Group>
      </Row>
      <Row className="mb-3">
        <Form.Group as={Col}>
          <Button
            variant="success"
            type="button"
            className="mr-1"
            onClick={() => handleClickSearch(form)}
          >
            検索
          </Button>
          <Button variant="secondary" type="button" onClick={handleClear}>
            クリア
          </Button>
        </Form.Group>
      </Row>
      <Row className="mb-3">
        <Col as="small">
          一覧には最大10000件まで表示されます
          <br />
          エラーがあった場合はコンソールに表示されます
        </Col>
      </Row>
    </Form>
  );
};

export default LogSearchForm;
